import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue';
import { Portal } from '@/modules/common/components/Portal';
import { Modal, HelperViewContextual } from '@warrenbrasil/nebraska-web';
import { customerAPI } from '@/modules/common/services/http/customer';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/wallet-builder/src/types';
import { CustomerModule } from '@/modules/common/store/CustomerModule';

interface Props {
  isOpen: boolean;
}
interface Emits {
  (e: 'close'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'VerifyEmailModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {





const isLoading = ref(false);
const customerEmail = ref('');

const handleClose = () => {
  emit('close');
};

const descriptionComputed = computed(
  () =>
    `Enviamos um link para o e-mail ${customerEmail.value}. Acesse-o para prosseguir com a validação.`
);

const getCustomerEmail = async () => {
  isLoading.value = true;
  try {
    customerEmail.value = CustomerModule.getCustomer?.email ?? '';
    isLoading.value = false;
  } catch (_) {
    notify({
      group: 'wrn-notifications',
      text: 'Tivemos um problema para obter seu e-mail. Tente novamente.',
      type: NotificationTypes.error
    });
    handleClose();
  }
};

const handleResendEmail = async () => {
  isLoading.value = true;
  try {
    await customerAPI.checkAccount(customerEmail.value);
    isLoading.value = false;
    notify({
      group: 'wrn-notifications',
      text: 'Pronto, enviamos um novo e-mail.',
      type: NotificationTypes.success
    });
    handleClose();
  } catch (_) {
    isLoading.value = false;
    notify({
      group: 'wrn-notifications',
      text: 'Tivemos um problema para enviar o e-mail. Tente novamente.',
      type: NotificationTypes.error
    });
    handleClose();
  }
};

onMounted(getCustomerEmail);

return { __sfc: true,emit, isLoading, customerEmail, handleClose, descriptionComputed, getCustomerEmail, handleResendEmail, Portal, Modal, HelperViewContextual }
}

})